import {
  type GenericDetailQueryKey,
  type GenericListQueryKey,
  generateDetailQueryKey,
  generateListQueryKey,
} from '@pba/react-query';

const communitiesFeatureKey = ['communities'] as const;

type CommunityMembersListQuery = GenericListQueryKey<CommunityMembersQueryFilter>;

type CommunityMembersQueryFilter = {
  communityId?: string;
};

export const getCommunityMembersListQueryKey = generateListQueryKey({
  prefix: [...communitiesFeatureKey, 'members'],
})<CommunityMembersListQuery>;

// TODO: This hand-built prefix is outside the generateListQueryKey standard. Invalidate with getCommunityMembersListQueryKey({}) instead, the way other features drop every list variant.
export const getCommunityMembersQueriesKey = () => [...communitiesFeatureKey, 'members', 'list'] as const;

export const getInvitationTokenQueryKey = generateDetailQueryKey({
  prefix: [...communitiesFeatureKey, 'invitation-token'],
})<GenericDetailQueryKey>;
